import { Dialog, DialogContent } from '@mui/material';
import PropTypes from 'prop-types';
import { LABELS } from '../../constants/common';
import { Label } from '../Label';

export const ViewPropertyDialog = ({
  open,
  handleClose,
  classes,
  dialogIcon,
  propertyData,
  ...restProps
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className="View-user-wrapper view-brokerage-wrapper custom-dialog"
      classes={classes}
      {...restProps}>
      <div className="dialog-content-wrapper">
        <div className="title-wrapper">
          <Label variant="h3" label={LABELS.VIEW_PROPERTY} />
          <button className="close-icon" onClick={handleClose} name="close">
            <img src={dialogIcon} alt="close icon" />
          </button>
        </div>
        <DialogContent>
          <div className="user-detail-wrapper">
            <div className="single-detail-wrapper">
              <span className="label">Office Name</span>
              <div className="detail">
                <p>{propertyData?.brokerageOfficeName}</p>
              </div>
            </div>
            <div className="single-detail-wrapper">
              <span className="label">Address</span>
              <div className="detail">
                <p>{propertyData?.address}</p>
              </div>
            </div>
            <div className="single-detail-wrapper">
              <span className="label">State</span>
              <div className="detail">
                <p>{propertyData?.state}</p>
              </div>
            </div>
            <div className="single-detail-wrapper">
              <span className="label">City</span>
              <div className="detail">
                <p>{propertyData?.city}</p>
              </div>
            </div>
            <div className="single-detail-wrapper">
              <span className="label">Zip Code</span>
              <div className="detail">
                <p>{propertyData?.zip5}</p>
              </div>
            </div>
            <div className="single-detail-wrapper">
              <span className="label">Stage</span>
              <div className="detail">
                <p>{propertyData?.stage}</p>
              </div>
            </div>
            <div className="single-detail-wrapper">
              <span className="label">Latest Note</span>
              <div className="detail">
                <p>{propertyData?.note}</p>
              </div>
            </div>
            <div className="single-detail-wrapper">
              <span className="label">Tagged Date</span>
              <div className="detail">
                <p>{propertyData?.dateTagged}</p>
              </div>
            </div>
            <div className="single-detail-wrapper">
              <span className="label">Status</span>
              <div className="detail">
                <span className={`status-badge ${propertyData?.status?.toLowerCase() || ''}`}>
                  {propertyData?.status}
                </span>
              </div>
            </div>
            <div className="single-detail-wrapper">
              <span className="label">Realtor</span>
              <div className="detail">
                <p> {`${propertyData?.realtorFirstName} ${propertyData?.realtorLastName}`}</p>
              </div>
            </div>
            <div className="single-detail-wrapper">
              <span className="label">MLS/Source</span>
              <div className="detail">
                <p> {propertyData?.MLS}</p>
              </div>
            </div>
          </div>
        </DialogContent>
      </div>
    </Dialog>
  );
};

ViewPropertyDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func,
  classes: PropTypes.object,
  dialogIcon: PropTypes.string,
  propertyData: PropTypes.object
};
